<template>
<div>
    <eBillingFileType-list></eBillingFileType-list>
</div>
</template>

<script>
export default {}
</script>
